import { h, Component, Element, Listen, Prop, State, Watch }
  from '@stencil/core';
import ProjectManager from './project-manager';
import Project from './project';


@Component({
  tag: 'tip-root',
  styleUrl: 'root.css'
})
export class Root {
  styleEl: HTMLGlStyleElement;
  subtitle: string;
  title: string;

  @Element() el: HTMLElement;
  @State() features: any[] = [];
  @State() filteredProjects: Project[] = [];
  @State() expanded: number[] = [];
  @Prop({ mutable: true }) completeProjects: any[] = [];
  @Prop() siteTitle: string;
  @Prop() author: string;
  @Prop() baseUrl: string;
  @Prop() layers: string;
  @Prop() legendOptions: any[];
  @Prop() projectManager: any = new ProjectManager();
  @Prop() revision: number = 1;
  @Prop() iconUrl: string;

  @Prop() sortOrder: {} = {
    attribute: 'project_title',
    order: 'asc'
  }

  componentWillLoad() {
    this.updateTitle();
  }

  async componentDidLoad() {
    let layers = await Promise.all(
      this.layers.split(',')
        .map((layer) => this.fetchJSON(
          `${this.baseUrl}/data/${layer}.geojson?rev=${this.revision}`)));
    this.features = [];
    for (let layer of layers) this.features.push(...layer.features);
    this.filteredProjects = this.projectManager.createProjects(this.features);
    this.completeProjects = this.projectManager.createProjects(this.features);
  }

  async fetchJSON(url: string) {
    let res = await fetch(url);
    return await res.json();
  }

  loadGlComponents() {
    // This method is not actually called.
    // It tell the Stencil compiler to include elements in the bundle
    // that will be used in index.html.
    return (<gl-table-column>
      <ion-select-option></ion-select-option>
    </gl-table-column>);
  }

  @Listen('glFiltersUpdate')
  handleFiltersUpdate(event: CustomEvent) {
    this.filteredProjects = this.projectManager.getProjects(
      event.detail.selectionFilters)
  }

  @Listen('glTableSort')
  handleTableSort(e: CustomEvent) {
    this.filteredProjects = ProjectManager.sortProjects(
      this.filteredProjects, e.detail.attribute, e.detail.order)
  }

  @Listen('updateExpanded')
  handleTableExpanded(e) {
    let expanded = [...this.expanded];
    if (e.detail.expanded) {
      expanded.push(e.detail.feature.properties.tip_id)
    } else {
      expanded = expanded.filter((tipId) => {
        return tipId !== e.detail.feature.properties.tip_id
      })
    }
    this.expanded = expanded;
  }

  @Watch('siteTitle')
  updateTitle() {
    if (!this.siteTitle) {
      this.title = null;
      this.subtitle = null;
      return;
    }

    let parts = this.siteTitle.split(': ');
    this.title = parts[0];
    this.subtitle = (parts[1]) ? parts[1] : null;
  }


  createTable() {
    let features = [];
    let keys = Object.keys(this.filteredProjects)
    for (let key of keys) {
      let project = this.filteredProjects[key];
      let expanded = (this.expanded.indexOf(project.id) > -1 ? true : false);
      let tableRows = project.getTableRows(expanded);
      if (tableRows[0] !== undefined) {
        features = features.concat(tableRows)
      }
    }
    return (
      <gl-table features={features} disableDefaultSort={true}
        rowClassAttribute='rowClassAttribute'>
        <slot name="table-columns" />
      </gl-table>
    )
  }

  render() {
    let mapFeatures = [];
    let tableFeatures = [];
    for (let project of this.filteredProjects) {
      if (project.id || project.id === 0) mapFeatures.push(project.id);
      tableFeatures.push(...project.getTableRows());
    }
    return (
      <gl-app splitPane={false} menuLabel='Filter Projects' label={this.siteTitle} menuType='overlay'>
        <img src={this.iconUrl} height='50' width='50'
          alt='RPC'
          slot="start-buttons" />
        <gl-fullscreen slot="end-buttons"></gl-fullscreen>
        <gl-basemaps slot="end-buttons"></gl-basemaps>
        <gl-drawer-toggle icon="grid-sharp" slot="end-buttons"
          buttonTitle="Toggle project details table"></gl-drawer-toggle>
        <tip-legend-button slot="end-buttons"
          options={this.legendOptions}
          revision={this.revision}></tip-legend-button>
        <tip-info-button slot='end-buttons'></tip-info-button>
        <gl-map
          longitude={-88.228878} latitude={40.110319} zoom={12} maxzoom={22}>
          <tip-style
            url={`${this.baseUrl}/style/style.json?rev=${this.revision}`}
            tipIds={mapFeatures}
            layerNames={this.layers}></tip-style>
          <slot name="basemaps"></slot>
        </gl-map>
        <div slot="menu">
          <slot name="tip-filters" />
        </div>
        <gl-drawer open={true}
          drawerTitle='Project Details' slot="after-content">
          <gl-table-column-visibility-button slot='toolbar-end-buttons'>
          </gl-table-column-visibility-button>
          <gl-table-export-button format="csv" slot="toolbar-end-buttons"
            page-title={this.title} page-subtitle={this.subtitle}>
          </gl-table-export-button>
          <gl-table-export-button format="pdf" slot="toolbar-end-buttons"
            page-title={this.title} page-subtitle={this.subtitle}
            author={this.author} page-orientation="landscape"
            url='https://pdf.ccrpc.org/pdf/'>
          </gl-table-export-button>

          {this.createTable()}
          <tip-pdf-export></tip-pdf-export>
        </gl-drawer>
      </gl-app>
    );
  }
}
